const StoreColumn = () => {

    const columns = [{
        title: 'ردیف', dataIndex: 'row', key: 'row', render: (text, row, index) => {
            return index + 1;
        },
    },

        {
            title: 'کالا',
            dataIndex: 'product',
            key: 'product',
        },
        {
            title: 'کد کالا',
            dataIndex: 'productCode',
            key: 'productCode',
        },


        // {
            // title: 'تعداد پالت ',
            // dataIndex: 'palletsCount',
            // key: 'palletsCount',
        // },
        {
            title: 'تعداد کالا',
            dataIndex: 'numberInPalletCount',
            key: 'numberInPalletCount',
        },




    ];
    return [columns];
};

export default StoreColumn;